import React from 'react';

const OurStoryPage = () => {
return (
<>
  <section className="ourstory-main bg-250147">
    <i className="glow-4" />
    <i className="wave" />
    <div className="container-lg inner-container position-relative">
      <div className="text-center text-white">
        <h1 className="our-s-head">Our Story</h1>
        <h5 className="our-sub-head">
          Every company has a story, and this is ours.
        </h5>
      </div>
      <div className="our-stry-bx-main">
        <div className="our-stry-bx _1"></div>
        <div className="our-stry-bx _2">
          <div className="">
            <img src="assets/img/establish.svg" alt=" " />
            <p>
              Established in <span>2005</span>
            </p>
          </div>
        </div>
        <div className="our-stry-bx _3">
          <div className="">
            <img src="assets/img/teams.svg" alt=" " />
            <h5>
              60<sup>+</sup> team
            </h5>
            <p>of writers, designers, and digital specialists</p>
          </div>
        </div>
        <div className="our-stry-bx _4">
          <div className="">
            <img src="assets/img/clients-acquired.svg" alt=" " />
            <div className="supl-flex mt-3">
              <div className="suplcnt">
                <h5>
                  8<sup>+</sup>
                </h5>
              </div>
              <div className="">
                <p>clients acquired</p>
              </div>
            </div>
            <div className="supl-flex">
              <div className="suplcnt">
                <h5>2</h5>
              </div>
              <div className="">
                <p>clients IPO</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-xl-11">
          <div className="tolls text-white">
            <div className="tolls-icon icon-list brilliant-campaigns"></div>
            <div className="tolls-cnt">
              <div className="row">
                <div className="col-xxl-8">
                  <h5>
                    Deliver{" "}
                    <span className="c-F0B2FF">brilliant campaigns</span> &amp;
                    create <span className="c-F0B2FF">Inspiring brands</span>.
                  </h5>
                </div>
              </div>
              <p>
                B2B products and services are the engines that fuel global
                organizations to expand even while they mitigate inherent risks,
                and deliver rich customer experiences. But too often, your B2B
                product or service business is stuck in rigid NDAs, corporate
                speak, and uninspiring campaigns that don’t move the needle for
                corporate buying groups.
              </p>
              <p>
                This is where we can help. Since 2005, we have worked with
                numerous small, medium, and large B2B products and services
                firms to break out of their molds, deliver brilliant campaigns,
                and create inspiring brands.
              </p>
              <p>
                We remain laser-focused on helping our clients shorten the time
                to achieve their goals: whether it be increasing revenue,
                expanding into new markets, attracting top talent, setting up
                for an IPO or for an acquisition.
              </p>
            </div>
          </div>
          <div className="tolls text-white">
            <div className="tolls-icon icon-list one-size"></div>
            <div className="tolls-cnt">
              <div className="row">
                <div className="col-xxl-8">
                  <h5>
                    From one-size fits marketing all to{" "}
                    <span className="c-F0B2FF">
                      audience-based persona-driven customized marketing program
                    </span>
                    .
                  </h5>
                </div>
              </div>
              <p>
                Since inception, we have continuously evolved as the technology
                markets have evolved and grown: from how smart phones changed
                content consumption patterns, from traditional enterprise
                license marketing to setting up clients for SaaS licenses and
                customer retention, from one-size fits all marketing to
                audience-based persona-driven customized marketing programs, and
                executing integrated campaigns that drive double digit
                conversions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="testimonial-s">
    <div className="container-lg inner-container">
      <h3 className="testi-head">Testimonials</h3>
    </div>
    <div className="owl-pl">
      <div className="owl-carousel cc-testimonial">
        <div className="item">
          <div className="item-boxs">
            <p>
              “Purplepatch is a great partner who have helped amplify our brand,
              engage in everything digital for our presence, and execute a
              full-cycle marketing program for us. We continue to leverage their
              outsourced marketing office as a key component of our growth. From
              web presence to social media to product design experience, they
              deliver amazing results.”
            </p>
            <div className="pople">
              <div className="d-flex testimonial-pople">
                <div className="hd">
                  <img src="assets/img/sutherson.png" alt="Sudarshan" />
                </div>
                <div className="">
                  <h5>Sudarshan Vasudevan</h5>
                  <h6>CEO, Qubercomm</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="item-boxs">
            <p>
              “Xoriant and Purplepatch share a long legacy of marketing, and are
              a partner in our evolution from staffing to solutions-based
              organization.”
            </p>
            <div className="pople">
              <div className="d-flex testimonial-pople">
                <div className="hd">
                  <img src="assets/img/sutherson.png" alt="Sudarshan" />
                </div>
                <div className="">
                  <h5>David Sawatzke </h5>
                  <h6>Head of Marketing, Xoriant</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="item-boxs">
            <p>
              “Our go-to agency, the team re-launched our website in record
              time, and deliver great content, inside sales support, and lead
              qualification for our marketing.”
            </p>
            <div className="pople">
              <div className="d-flex testimonial-pople">
                <div className="hd">
                  <img src="assets/img/sutherson.png" alt="Sudarshan" />
                </div>
                <div className="">
                  <h5>Keao Caindec</h5>
                  <h6>VP Marketing, Mocana</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="item-boxs">
            <p>
              “We as marketing professionals, whether focused on B2B or B2C,
              know the website is the heart of both brand awareness and demand
              generation initiatives. The transition from stealth to Series A
              required the execution of the organization’s first integrated
              marketing program, and that meant a full transformation of our
              website from a single landing page to an end-to-end discovery to
              evaluation content journey. The core scope of the initiative
              included a site that is self-service driven by non-technical
              marketers, integrated into our HubSpot marketing automation
              platform, and user-friendly. With nearly 12 months under our belt,
              we are on our way to higher quality and lower cost MQLs. The
              Purplepatch team has continuously been very responsive with quick
              turn around.”
            </p>
            <div className="pople">
              <div className="d-flex testimonial-pople">
                <div className="hd">
                  <img src="assets/img/sutherson.png" alt="Sudarshan" />
                </div>
                <div className="">
                  <h5>Bennett Sung</h5>
                  <h6>AllyO | Head of Marketing</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section
    className="get-form-touch"
    style={{ backgroundImage: "url(assets/img/get-form-touch.png)" }}
  >
    <div className="container-lg inner-container">
      <div className="row">
        <div className="col-md-6 text-white">
          <h5 className="ss-1">Contact</h5>
          <h4 className="ss-2">
            Ready to start your growth with Our B2B Digital Marketing Service?
          </h4>
          <div className="home-feat-article">
            <div className="dflex-1 text-black">
              <div className="dflex-1-cnt">
                <h6>Featured Article</h6>
                <h5>What is good conversion rate?</h5>
              </div>
              <div className="dflex-1-icon">
                <img src="assets/img/peop-1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 text-white">
          <h6 className="ss-3">
            Your success story begins here. Connect with us today!
          </h6>
          <p>
            Are you ready to start elevating your brand and getting results?
            Then stop reading and start typing! Fill out the form and let’s
            begin…
          </p>
        </div>
      </div>
    </div>
  </section>
</>
  );
};

export default OurStoryPage;